exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-message[data-v-252f9eca]{padding:16px 20px;border-radius:8px;display:flex;align-items:center;gap:12px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,sans-serif;font-size:15px;line-height:1.5}.status-message.success[data-v-252f9eca]{background-color:#e7f6ee;border:1px solid #d1e9db;color:#0a3622}.status-message.success .icon[data-v-252f9eca]{color:#16a34a}.status-message .icon[data-v-252f9eca]{flex-shrink:0;width:20px;height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-252f9eca","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Stripe/SuccessResponse.vue
// module id = hzr1
// module chunks = 0